/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import ModalDefunt from './ModalDefunt';

/** Props reçues du registre de fiche, transmises telles quelles. */
type ProprietesModaleIndividu = React.ComponentProps<typeof ModalDefunt>;

/**
 * Sections « INFORMATIONS DE NAISSANCE » et « DOMICILIATION » de l'onglet d'un
 * conjoint — le premier des deux groupes.
 *
 * ⚠️ Aucun code propre : c'est `ModalDefunt` sous un autre titre. Ce qu'elle
 * édite — état civil, lieu de naissance, domicile — est identique et vit sur
 * `ec_acte_individu`, écrit par le même `PUT /acte-individus/{id}`. Deux
 * enveloppes suffisent, le registre de la fiche montant les modales sans leur
 * passer d'argument.
 *
 * La situation antérieure et la profession sont dans le second groupe
 * (`ModalConjointDivers`), comme la profession du défunt.
 */
export const ModalConjoint1 = (props: ProprietesModaleIndividu) => (
  <ModalDefunt {...props} titre="Modifier le 1er conjoint" />
);

export const ModalConjoint2 = (props: ProprietesModaleIndividu) => (
  <ModalDefunt {...props} titre="Modifier le 2eme conjoint" />
);

export default ModalConjoint1;
